import type { ComponentType, ReactNode } from 'react';

import AccessSkin from './AccessSkin';

/**
 * A preview skin is the page chrome a consuming app renders AROUND a slot
 * (headers, hero backgrounds, greetings) — replicated statically so the
 * editor preview shows the screen the way members will see it, not the
 * slot's blocks floating on a bare background. Skins wrap the rendered
 * region inside the phone frame; the blocks themselves stay fully
 * interactive editor content.
 */
export type PreviewSkin = ComponentType<{ children: ReactNode }>;

/** slotKey → the chrome the app mounts that slot inside. */
const PREVIEW_SKINS: Record<string, PreviewSkin> = {
  'access.body': AccessSkin,
};

/** Undefined = no skin registered; the preview renders the bare region. */
export function getPreviewSkin(slotKey?: string): PreviewSkin | undefined {
  return slotKey ? PREVIEW_SKINS[slotKey] : undefined;
}
